/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CabinClassCriteriaDto,
    CabinClassCriteriaDtoFromJSON,
    CabinClassCriteriaDtoFromJSONTyped,
    CabinClassCriteriaDtoToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
    SearchTravelRange,
    SearchTravelRangeFromJSON,
    SearchTravelRangeFromJSONTyped,
    SearchTravelRangeToJSON,
    TicketTimeLimitOverrideTimeConfigItem,
    TicketTimeLimitOverrideTimeConfigItemFromJSON,
    TicketTimeLimitOverrideTimeConfigItemFromJSONTyped,
    TicketTimeLimitOverrideTimeConfigItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLOFormData
 */
export interface TTLOFormData {
    /**
     * 
     * @type {string}
     * @memberof TTLOFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {object}
     * @memberof TTLOFormData
     */
    effectiveDateFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TTLOFormData
     */
    effectiveDateTo?: object | null;
    /**
     * 
     * @type {number}
     * @memberof TTLOFormData
     */
    relevance?: number;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof TTLOFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<string>}
     * @memberof TTLOFormData
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOFormData
     */
    excludeAccountCodes?: boolean;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof TTLOFormData
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof TTLOFormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof TTLOFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<CabinClassCriteriaDto>}
     * @memberof TTLOFormData
     */
    cabinClasses?: Array<CabinClassCriteriaDto> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TTLOFormData
     */
    salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TTLOFormData
     */
    bookingClasses?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOFormData
     */
    excludeBookingClasses?: boolean;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof TTLOFormData
     */
    providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof TTLOFormData
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof TTLOFormData
     */
    marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof TTLOFormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOFormData
     */
    includeDateTimeRestrictions?: boolean;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof TTLOFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {Array<SearchTravelRange>}
     * @memberof TTLOFormData
     */
    travelDates?: Array<SearchTravelRange> | null;
    /**
     * 
     * @type {number}
     * @memberof TTLOFormData
     */
    dayOffset?: number;
    /**
     * 
     * @type {TicketTimeLimitOverrideTimeConfigItem}
     * @memberof TTLOFormData
     */
    time?: TicketTimeLimitOverrideTimeConfigItem;
    /**
     * 
     * @type {string}
     * @memberof TTLOFormData
     */
    cloneSourceId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TTLOFormData
     */
    overrideDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TTLOFormData
     */
    offsetDays?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TTLOFormData
     */
    description?: string | null;
}

export function TTLOFormDataFromJSON(json: any): TTLOFormData {
    return TTLOFormDataFromJSONTyped(json, false);
}

export function TTLOFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'effectiveDateFrom': !exists(json, 'effectiveDateFrom') ? undefined : json['effectiveDateFrom'],
        'effectiveDateTo': !exists(json, 'effectiveDateTo') ? undefined : json['effectiveDateTo'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'excludeAccountCodes': !exists(json, 'excludeAccountCodes') ? undefined : json['excludeAccountCodes'],
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassCriteriaDtoFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : json['bookingClasses'],
        'excludeBookingClasses': !exists(json, 'excludeBookingClasses') ? undefined : json['excludeBookingClasses'],
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'includeDateTimeRestrictions': !exists(json, 'includeDateTimeRestrictions') ? undefined : json['includeDateTimeRestrictions'],
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SearchTravelRangeFromJSON)),
        'dayOffset': !exists(json, 'dayOffset') ? undefined : json['dayOffset'],
        'time': !exists(json, 'time') ? undefined : TicketTimeLimitOverrideTimeConfigItemFromJSON(json['time']),
        'cloneSourceId': !exists(json, 'cloneSourceId') ? undefined : json['cloneSourceId'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'overrideDays': !exists(json, 'overrideDays') ? undefined : json['overrideDays'],
        'offsetDays': !exists(json, 'offsetDays') ? undefined : json['offsetDays'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function TTLOFormDataToJSON(value?: TTLOFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'effectiveDateFrom': value.effectiveDateFrom,
        'effectiveDateTo': value.effectiveDateTo,
        'relevance': value.relevance,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'accountCodes': value.accountCodes,
        'excludeAccountCodes': value.excludeAccountCodes,
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassCriteriaDtoToJSON)),
        'salesJourneys': value.salesJourneys === undefined ? undefined : (value.salesJourneys === null ? null : (value.salesJourneys as Array<any>).map(CodeAndLabelToJSON)),
        'bookingClasses': value.bookingClasses,
        'excludeBookingClasses': value.excludeBookingClasses,
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'marketingCarriers': value.marketingCarriers === undefined ? undefined : (value.marketingCarriers === null ? null : (value.marketingCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'includeDateTimeRestrictions': value.includeDateTimeRestrictions,
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SearchTravelRangeToJSON)),
        'dayOffset': value.dayOffset,
        'time': TicketTimeLimitOverrideTimeConfigItemToJSON(value.time),
        'cloneSourceId': value.cloneSourceId,
        'allowEdit': value.allowEdit,
        'overrideDays': value.overrideDays,
        'offsetDays': value.offsetDays,
        'description': value.description,
    };
}


